module.exports = __webpack_public_path__ + "img/logo-accc.ab73127d.png";